<div class="menu-aside" [class.asidetxt]="!asidetxt">
  <div class="contop">
    <div
      class="news"
      *ngIf="
        user?.groups?.includes('SUBSCRIPTION_ALL') ||
        user?.roles?.includes('SUBSCRIPTION_ALL') ||
        user?.groups?.includes('SUBSCRIPTION_NEWS') ||
        user?.roles?.includes('SUBSCRIPTION_NEWS')
      "
    >
      <div class="tito">News</div>
      <div
        class="mainmenu"
        [class.light]="routing.theme === 'light'"
        matTooltip="Portfolio"
        matTooltipPosition="right"
        routerLink="news/portfolio"
        routerLinkActive="active"
        [queryParams]="{
          id: null,
          eventid: null,
          eventype: null,
          scoreevent: null,
          tag: null,
        }"
        queryParamsHandling="merge"
      >
        <mat-icon>collections_bookmark</mat-icon>
        <span class="txt">Portfolio</span>
      </div>
      <div
        class="mainmenu"
        [class.light]="routing.theme === 'light'"
        matTooltip="Collection"
        matTooltipPosition="right"
        routerLink="news/query"
        routerLinkActive="active"
        [queryParams]="{
          id: null,
          eventid: null,
          eventype: null,
          scoreevent: null,
          tag: null,
        }"
        queryParamsHandling="merge"
      >
        <mat-icon>view_module</mat-icon>
        <span class="txt">Collection</span>
      </div>
      <div
        *ngIf="routing.isDev() || userInfo.isAdmin"
        class="mainmenu"
        [class.light]="routing.theme === 'light'"
        matTooltip="Market"
        matTooltipPosition="right"
        routerLink="news/sector"
        routerLinkActive="active"
        [queryParams]="{
          id: null,
          eventid: null,
          eventype: null,
          scoreevent: null,
          tag: null,
        }"
        queryParamsHandling="merge"
      >
        <mat-icon>public</mat-icon>
        <span class="txt">Market</span>
      </div>
      <div
        class="mainmenu"
        [class.light]="routing.theme === 'light'"
        matTooltip="Chat"
        matTooltipPosition="right"
        routerLink="chat"
        routerLinkActive="active"
      >
        <mat-icon>chat_question</mat-icon>
        <span class="txt">Chat</span>
      </div>
    </div>

    <div
      class="trend"
      *ngIf="
        featureFlagsService.featureFlags.showInvestLab &&
        (user?.groups?.includes('SUBSCRIPTION_ALL') ||
          user?.roles?.includes('SUBSCRIPTION_ALL') ||
          user?.groups?.includes('SUBSCRIPTION_TREND') ||
          user?.roles?.includes('SUBSCRIPTION_TREND'))
      "
    >
      <div
        class="space"
        *ngIf="
          user?.groups?.includes('SUBSCRIPTION_ALL') ||
          user?.roles?.includes('SUBSCRIPTION_ALL')
        "
      ></div>
      <div class="tito">Invest</div>

      <div
        *ngIf="featureFlagsService.featureFlags.showSignals"
        class="mainmenu"
        [class.light]="routing.theme === 'light'"
        matTooltip="Signals"
        matTooltipPosition="right"
        routerLink="invest/signal"
        routerLinkActive="active"
        [queryParams]="{
          id: null,
          eventid: null,
          eventype: null,
          scoreevent: null,
          tag: null,
          newstype: null,
        }"
        queryParamsHandling="merge"
      >
        <mat-icon svgIcon="chart-areaspline"></mat-icon>
        <span class="txt">Signals</span>
      </div>
      <div
        *ngIf="featureFlagsService.featureFlags.showTrending"
        class="mainmenu"
        [class.light]="routing.theme === 'light'"
        matTooltip="Trending"
        matTooltipPosition="right"
        routerLink="invest/trending"
        routerLinkActive="active"
        [queryParams]="{
          id: null,
          eventid: null,
          eventype: null,
          scoreevent: null,
          tag: null,
          newstype: null,
        }"
        queryParamsHandling="merge"
      >
        <mat-icon>whatshot</mat-icon>
        <span class="txt">Trending</span>
      </div>
      <div class="space"></div>
    </div>
    <div
      class="reports"
      *ngIf="
        routing.isDev() ||
        userInfo.isAdmin ||
        userInfo.hasRoleOrGroup('ORG_ZRCH')
      "
    >
      <div class="tito">Reports</div>
      <div
        *ngIf="routing.isDev() || userInfo.isAdmin"
        class="mainmenu"
        [class.light]="routing.theme === 'light'"
        matTooltip="Commodity Reports"
        matTooltipPosition="right"
        routerLink="reports/commodities"
        routerLinkActive="active"
      >
        <mat-icon>description</mat-icon>
        <span class="txt">Reports</span>
      </div>
      <div
        *ngIf="
          routing.isDev() ||
          userInfo.isAdmin ||
          userInfo.hasRoleOrGroup('ORG_ZRCH')
        "
        class="mainmenu"
        [class.light]="routing.theme === 'light'"
        matTooltip="Credit Due Diligence"
        matTooltipPosition="right"
        routerLink="reports/due-diligence"
        routerLinkActive="active"
      >
        <mat-icon>fact_check</mat-icon>
        <span class="txt">Due Diligence</span>
      </div>
    </div>
  </div>
  <div class="conbot">
    <div class="space"></div>
    <div
      class="mainmenu"
      [class.light]="routing.theme === 'light'"
      matTooltip="Newsletter"
      matTooltipPosition="right"
      routerLink="newsletter"
      routerLinkActive="active"
      [queryParams]="{
        id: null,
        eventid: null,
        eventype: null,
        scoreevent: null,
        tag: null,
      }"
      queryParamsHandling="merge"
    >
      <mat-icon>email</mat-icon>
      <span class="txt">Newsletter</span>
    </div>
    <div
      id="alert-settings"
      class="mainmenu"
      [class.light]="routing.theme === 'light'"
      matTooltip="Alerts"
      matTooltipPosition="right"
      (click)="openAlerts()"
      [style.opacity]="eventsList ? 1 : 0.5"
      [style.cursor]="eventsList ? 'pointer' : 'wait'"
    >
      <mat-icon>notifications</mat-icon>
      <span class="txt">Alerts</span>
    </div>

    <div
      class="btnmenu"
      [routerLink]="[]"
      [queryParams]="{ reflow: params.reflow === 'true' ? null : 'true' }"
      queryParamsHandling="merge"
      (click)="myAsidetxt()"
    >
      <mat-icon>keyboard_arrow_left</mat-icon>
    </div>
  </div>
</div>
